import React, { useEffect, useState } from "react";
import SubHeader from "../../../components/global-components/sub-header";
import { useAuth } from "../../../helpers/context";
import { getWLProfile } from "../../../api/userApi";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomerSupportIcon } from "../../../constants/icons";
import ConnectWithWhatsApp from "./components/connect-with-whatsapp";
import ConnectWithAnalytics from "./components/connect-with-analytics";
import ConnectWithGTM from "./components/connect-with-gtm";
// import io from 'socket.io-client';
// import QRCode from "react-qr-code";
// import { WHATSAPP_API } from "../../../constants";

// const socket = io.connect(WHATSAPP_API, {});


export default function Addons() {
  const { token, vendor, UserType } = useAuth();
  const [WlUser, setWlUser] = useState();
  const { t, i18n } = useTranslation();
  const [GTMId, setGTMId] = useState('');
  const [AnalyticsId, setAnalyticsId] = useState('');
  
  // useEffect(() => {
  //   if (number) {
  //     socket.emit("connected", "Hello from client");
    
  //     socket.on("qr", (data) => {
  //       console.log(data)
  //       console.log({ number })
  //       if (number === data.phone)
  //         setQR(data.qr);
  //     });

  //     socket.on("loggedIn", (data) => {
  //       if (number === data.phone)
  //         setIsLoggedIn(true);
  //     });

  //     socket.on("loggedOut", (data) => {
  //       if (number === data.phone)
  //         setIsLoggedIn(false);
  //     });
      
  //   }
    
  // }, [number]);
  
  const getData = () => {
    if (UserType !== '5') {
      getWLProfile({ userName: vendor, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
        if (_userInfo.resCode === 0) {
          setWlUser(_userInfo.response.wlUser);
          setGTMId(_userInfo.response.wlUser.gtm_container || '');
          setAnalyticsId(_userInfo.response.wlUser.gtm_measurement_id || '');
        }
      });
    }
  }

  useEffect(() => {
    if (token) {
      if (UserType !== '5') {
        getWLProfile({ userName: vendor, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
          if (_userInfo.resCode === 0) {
            setWlUser(_userInfo.response.wlUser);
            setGTMId(_userInfo.response.wlUser.gtm_container || '');
            setAnalyticsId(_userInfo.response.wlUser.gtm_measurement_id || '');
            // socket.emit("createSession", {
            //   phone: trimPhone(_userInfo.response.wlUser.whatsapp)
            // });
          }
        });
      } else {
        // getUserProile({ userId: token, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
        //   if (_userInfo.resCode === 0) {
        //     // socket.emit("createSession", {
        //     //   phone: trimPhone(_userInfo.response.userProfile.phone)
        //     // });
        //   }
        // });
      }

    }
  },  // eslint-disable-next-line
    [token, vendor, UserType]);
  
  return (
    <>
      <SubHeader OKElement={<></>} />
      <ConnectWithWhatsApp />

      {UserType !== '5' && (
        <>
          <ConnectWithGTM onOK={getData} WlUser={WlUser} GTMId={GTMId} setGTMId={setGTMId} />
          <ConnectWithAnalytics onOK={getData} WlUser={WlUser} AnalyticsId={AnalyticsId} setAnalyticsId={setAnalyticsId} />
        </>
      )}

      <div className='custom-card without-header call-us'>
        <div className="card-body">
          <div className="flex-wrapper">
            <div>
              <h5>{t("FacingProblemLinkingWithWhatsApp")}</h5>
              <p>{t("DoNotHesitateToContactUs")}</p>
            </div>
            <div>
              <Link to="/admin/ticket" className="primary-btn justify-content-between" >
                <CustomerSupportIcon />
                <span>
                  {t("CustomerSupport")}
                </span>
              </Link>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
}
